import * as React from 'react'
import InfoCard from 'components/Cards/InfoCard'
import { flow, map, mean, partial, __, uniqBy, get, countBy, values, filter } from 'lodash/fp'
import { round, Dictionary } from 'lodash'
import { ICall } from 'features/CallAnalytics/types'
import * as s from './KeyMetrics.scss'
import * as sLay from 'styles/modules/layout.scss'
import cn from 'classnames'
import * as sText from 'components/Text/Text.scss'

const roundTo = p => partial(round, [__, p])

const Metric = ({
  name,
  value,
  prevValue,
  valueUnit,
  title,
}: {
  name: string
  value: number
  prevValue: number
  valueUnit?: string
  title: string
}) => {
  const fraction = (value / prevValue) * 100 - 100
  const change = round(fraction, 1) || 0
  return (
    <div className={s.metric}>
      <div className={cn(sLay['layout-row'], sLay['layout-align-start-end'])}>
        <div className={s.number} title={title}>
          {value || 0}
          <small>{valueUnit}</small>
        </div>
        <div
          className={cn(s.change, change >= 0 ? sText.green : sText.warn)}
          title={`${change >= 0 ? 'Up' : 'Down'} ${Math.abs(
            change
          )}%. Pervious period: ${prevValue}`}
        >
          {change}%
        </div>
      </div>
      <div className={s.name} title={title}>
        {name}
      </div>
    </div>
  )
}

const calcAvgDuration = flow<ICall[], any, any, number>(map('duration'), mean, roundTo(2))
const calcUniqCallers = flow<ICall[], any, any>(uniqBy<ICall>('incomingCaller'), get('length'))
const calcRepeatCallerRatio = data => {
  const callersCount = countBy('incomingCaller')(data)
  const totalCallers = Object.keys(callersCount).length
  const numMultiCallers = flow<Dictionary<number>, any, any, number>(
    values,
    filter((count: number) => count > 1),
    get('length')
  )(callersCount)
  return roundTo(2)((numMultiCallers / totalCallers) * 100)
}

export interface IKeyMetricsProps {
  loading: boolean
  calls: ICall[]
  callsPrevious: ICall[]
  periodValue: number
  periodUnit: string
}

export class KeyMetrics extends React.Component<IKeyMetricsProps> {
  render() {
    const { loading, calls, callsPrevious, periodValue, periodUnit } = this.props

    return (
      <InfoCard
        style={{ height: '100%' }}
        title="Key Metrics"
        color="dark"
        loading={loading}
        allowOverflow
      >
        <Metric
          name="Total Call Volume"
          title={`Total number of calls received in the last ${periodValue} ${periodUnit}`}
          value={calls.length}
          prevValue={callsPrevious.length}
        />
        <Metric
          name="Total Unique Callers"
          title={`Total number of calls from unique callers in the last ${periodValue} ${periodUnit}`}
          value={calcUniqCallers(calls)}
          prevValue={calcUniqCallers(callsPrevious)}
        />
        <Metric
          name="Average duration"
          title={`Average call duration in minutes over the last ${periodValue} ${periodUnit}`}
          value={calcAvgDuration(calls)}
          valueUnit="min"
          prevValue={calcAvgDuration(callsPrevious)}
        />
        <Metric
          name="Repeat caller ratio"
          title={`Percentage of callers who made 2 or more calls in the last ${periodValue} ${periodUnit}`}
          value={calcRepeatCallerRatio(calls)}
          valueUnit="%"
          prevValue={calcRepeatCallerRatio(callsPrevious)}
        />
      </InfoCard>
    )
  }
}



// WEBPACK FOOTER //
// src/features/CallAnalytics/Cards/KeyMetrics/KeyMetrics.tsx